import { Button } from "@mui/material";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircle } from "react-icons/fa";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import { useChangePasswordMutation } from "../../../Service/settings";
import Toast from "../../../Component/DigitalMarketing/Toast";
import PermissionCheck from "../../../Component/PermissionCheck";

function PasswordUpdate({ form }) {
  const initialState = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };
  const [password, setPassword] = useState(initialState);
  const { open, message, openSnackBar, type } = useSnackbar();
  const [submit, setSubmit] = useState(false);
  const [err, setError] = useState("");
  const [changePassword,{ isLoading:updateLoading }] = useChangePasswordMutation();
  const handleChange = (event) => {
    const { name, value } = event.target;
    setSubmit(false);
    setPassword((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleSubmit = async () => {
    setSubmit(true);
    if (
      password.oldPassword.trim().length !== 0 &&
      password.newPassword.trim().length !== 0 &&
      password.confirmPassword.trim().length !== 0
    ) {
      try {
        const payload = await changePassword(password).unwrap();
        // console.log("fulfilled", payload);
        openSnackBar("Updated successfully");
        setSubmit(false);
        setPassword(initialState);
        setError("");
      } catch (error: any) {
        // openSnackBar(error.data.message, "error");
        setError(error.data.message);
        console.error("rejected", error);
      }
    }
  };
  return (
    <div className="mx-3 mt-2">
      <p>
        <b>Account password change</b>
      </p>
      <Row>
        <Toast open={open} type={type} message={message} />
        <Col md={6} className="mb-2">
          {err && <span className="center red-c">{err}</span>}
          {form.map((a, i) => {
            return (
              <div key={i} className="mb-2">
                <a.tag
                  {...a}
                  {...password}
                  // style={PermissionCheck("settings", "update") ? "" : "input-grey"}
                  // disab={PermissionCheck("settings", "update") ? false : true}
                  submit={submit}
                  handleChange={handleChange}
                />
              </div>
            );
          })}
        </Col>
        <Col md={6} className="password-rules mb-2">
          <div>
            <ul className="grey">
              <li>
                <p className="black">Password Requirements </p>
              </li>
              <li>
                <FaCircle className="blue-circle" />
                Minimum Password Length - 8
              </li>
              <li>
                <FaCircle className="blue-circle" />
                At Least one Numeric character (0-9)
              </li>
              <li>
                <FaCircle className="blue-circle" />
                At Least one Upper case and Lower case (A-Z)
              </li>
              <li>
                <FaCircle className="blue-circle" />
                At Least one Special Character (!, %,@,& etc)
              </li>
            </ul>
          </div>
        </Col>
       
          <Col md={12} className="mb-2">
            <div>
              <Button
                variant="outlined"
                onClick={() => setPassword(initialState)}
                className="me-2"
                id="btn-outline"
              >
                Cancel
              </Button>
              <Button variant="contained" disabled={updateLoading} onClick={handleSubmit} id="btn-add">
              {updateLoading?"Wait":"Change Password"}
              </Button>
            </div>
          </Col>
    
      </Row>
    </div>
  );
}

export default PasswordUpdate;
